












import { defineComponent } from "@vue/composition-api";
import { UseTimeAgo } from "@vueuse/components";
import { BAlert, BAvatar, BBadge, BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAlert,
        BButton,
        BAvatar,
        BBadge,
        UseTimeAgo,
    },
});
